export const geocodeAddress = async (searchTerm) => {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API;
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${searchTerm}&key=${apiKey}`;
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (response.status === 200 && data.results.length > 0) {
            const lat = data.results[0].geometry.location.lat;
            const long = data.results[0].geometry.location.lng;
            return { latitude: lat, longitude: long };
        } else {
            console.error('Geocoding failed');
        }
    } catch (error) {
        console.error('An error occurred: ', error);
    }
};

export const geocodeAddressReverse = async (latitude, longitude) => {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API;
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (response.status === 200 && data.results.length > 0) {
            const addressComponents = data.results[0].address_components;
            let city = null;
            let region = null;

            addressComponents.forEach((component) => {
                if (component.types.includes('locality')) {
                    city = component.long_name;
                } else if (
                    component.types.includes('administrative_area_level_1')
                ) {
                    region = component.long_name;
                }
            });

            return city || region || 'Map Area';
        } else {
            console.error('Reverse geocoding failed');
        }
    } catch (error) {
        console.error('An error occurred: ', error);
        return null;
    }
};
